<template>
  <div class="IrCodeConvertor lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="IrCodeConvertor-topCurve-wrapper lxn-w100">
      <CustomCurve>
      </CustomCurve>
    </div>
    <div class="IrCodeConvertor-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <TitleBox :titleBgColor="'blue'" bgColor="#ECECEC">
        <template v-slot:title>
          IR Code Convertor
        </template>
        <template v-slot:body>
          Input
          <textarea style="width: 100%; height: 200px;" v-model="input"></textarea>
          Output
          <textarea style="width: 100%; height: 200px;" v-model="output"></textarea>
        </template>
      </TitleBox>
    </div>
    <div class="IrCodeConvertor-button lxn-margin-auto lxn-w100">
      <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        GO
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'IrCodeConvertor',
  components: {
    CustomCurve,
    CustomButton,
    TitleBox,
  },
  data: function () {
    return {
      input: '',
      output: '',
    }
  },
  mounted: function () {
    var messagingHook = new Messaging(new Logger(false));
    var command = [9024,4512,564,564,564,564,564,1692,564,564,564,564,564,564,564,564,564,564,564,1692,564,1692,564,564,564,1692,564,1692,564,1692,564,1692,564,1692,564,1692,564,564,564,564,564,564,564,564,564,564,564,1692,564,564,564,564,564,1692,564,1692,564,1692,564,1692,564,1692,564,564,564,1692,564,39756,9024,4512,564,564,564,564,564,1692,564,564,564,564,564,564,564,564,564,564,564,1692,564,1692,564,564,564,1692,564,1692,564,1692,564,1692,564,1692,564,1692,564,564,564,564,564,564,564,564,564,564,564,1692,564,564,564,564,564,1692,564,1692,564,1692,564,1692,564,1692,564,564,564,1692,564,39756];

    console.log(command.length)
    var command = messagingHook.irf.generateIrfByteStream(command);
    console.log(command);
    console.log(command.length);
  },
  destroyed: function () {
  },
  watch: {
    input: function (newVal) {
      var messagingHook = new Messaging(new Logger(false));
      var lines = this.input.split('\n');
      var deviceName = lines[0];
      var packetStartPos = 0;
      var outputPacket = [];
      var packetName = '';
      var tempPacketName = '';
      var command = '';
      var packetPending = false;
      for(var i = 0; i < lines.length; i++){
        packetStartPos = lines[i].indexOf('/////////////////////////////');
        if(packetStartPos != -1){
          packetStartPos += 30;
          tempPacketName = lines[i].substring(packetStartPos);
          packetPending = true;
          continue;
        }
        if(packetPending){
          packetPending = false;
          command = lines[i].replaceAll('+','').replaceAll('-','');
          // command = "[" + command + ',' + command + "]";
          command = "[" + command + "]";
          command = JSON.parse(command);
          command = messagingHook.irf.generateIrfByteStream(command);
          outputPacket.push({
            name: tempPacketName,
            command: command,
          });
          command = '';
        }
      }
      this.output = 'var ' + deviceName + ' = {\n' +
                    '    name: "' + deviceName + '",\n' +
                    '    defaultCommandIndex: 1,\n' +
                    '    commands: [\n';
      for(i = 0; i < outputPacket.length; i++){
        this.output += '        {\n' +
                        '            function: "' + outputPacket[i].name + '",\n' +
                        '            name: "' + outputPacket[i].name + '",\n' +
                        '            icon: "' + outputPacket[i].name + '",\n' +
                        '            command: ' + JSON.stringify(outputPacket[i].command) + ',\n' +
                        '        },\n';
      }
      this.output += '    ]\n' +
                    '}\n' +
                    'export default ' + deviceName;
    }
  },
  computed: {
    outputText: function () {
      // var rfPacketStringified = '';
      // try {
      //   rfPacketStringified = JSON.stringify(this.rfPacket);
      // }
      // catch (err) {
      //   rfPacketStringified = '';
      // }
      // return rfPacketStringified;
      // return this.input.length;
    }
  },
  methods: {
    saveChanges: function () {
    },
  }
}
</script>

<style>
  .IrCodeConvertor-topCurve-wrapper {
    height: 200px;
  }
  .IrCodeConvertor-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .IrCodeConvertor-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
</style>
